import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _toArray from "@babel/runtime/helpers/toArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var HandlerBase = /*#__PURE__*/function () {
  function HandlerBase() {
    _classCallCheck(this, HandlerBase);
    _defineProperty(this, "registeredHandlers", new WeakMap());
  }
  _createClass(HandlerBase, [{
    key: "registerHandler",
    value:
    /**
     * Registered events do not need detaching, it happens
     * automatically when detachHandlers is called
     */
    function registerHandler(_ref, eventType, handler, options) {
      var _this = this;
      var _ref2 = _toArray(_ref),
        domNode = _ref2[0],
        args = _ref2.slice(1);
      var customHandler = function customHandler(event) {
        return handler.call.apply(handler, [_this, event].concat(_toConsumableArray(args)));
      };
      this.registeredHandlers.set(domNode, [].concat(_toConsumableArray(this.registeredHandlers.get(domNode) || []), [[eventType, customHandler, options]]));
      domNode.addEventListener(eventType, customHandler, options);
    }
  }, {
    key: "detachHandlers",
    value:
    /**
     * if extended, super must be called
     */
    function detachHandlers(domNode) {
      (this.registeredHandlers.get(domNode) || []).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 3),
          eventType = _ref4[0],
          handler = _ref4[1],
          options = _ref4[2];
        domNode.removeEventListener(eventType, handler, options);
      });
      this.registeredHandlers.delete(domNode);
    }
  }]);
  return HandlerBase;
}();